import reactDom from 'react-dom';
import { MessageGlobal } from '@able/react';
import React from 'react';
import { getAbleSpriteSheet, isOutageWindow } from '../../../adapters/utils';

const ableSpriteSheet = getAbleSpriteSheet();

export function GlobalMessage() {

    const { PPA_GLOBAL_BANNER_TEXT, PPA_GLOBAL_BANNER_START_TIME, PPA_GLOBAL_BANNER_END_TIME } = window.appConfig;
    const show = isOutageWindow(PPA_GLOBAL_BANNER_START_TIME, PPA_GLOBAL_BANNER_END_TIME);
    const globalMessages = [];

    // Global banner message
    if (show) {
        globalMessages.push(
            <MessageGlobal
                developmentUrl={ableSpriteSheet}
                variant="Attention"
                description={PPA_GLOBAL_BANNER_TEXT}
            />
        );
    }

    // 3G exit global banner
    globalMessages.push(
        <MessageGlobal
            developmentUrl={ableSpriteSheet}
            variant="Attention"
            description={
                <>
                    Before you activate, ensure your mobile device is compatible with our 4G/5G network and is able to make emergency calls, including 000. {' '}
                    <a href="https://boost.com.au/pages/3g-network-closure?_pos=1&_sid=519506eac&_ss=r&_gl=1*14o4ud8*_gcl_au*NzYxNjA0ODg2LjE3Mjk2NDI0MTE" target="_blank">For Information</a>
                </>
            }
        />
    );

    return reactDom.createPortal(
        <div>
            {globalMessages}
        </div>,
        document.getElementById('global-message')
    );
}